<mat-button-toggle-group
  [hideSingleSelectionIndicator]="true"
  [value]="selectedValue"
  (change)="onToggleChange($event.value)"
>
  @for (option of options; track option.value) {
    <mat-button-toggle [value]="option.value">
      <span translate>{{ option.label }}</span>
    </mat-button-toggle>
  }
</mat-button-toggle-group>
